{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://kmap.dev/schemas/semantic-chart-config/1.0.0",
  "title": "SemanticChartConfig",
  "description": "Agent 语义化图表配置",
  "type": "object",
  "required": ["version", "data"],
  "additionalProperties": false,
  "properties": {
    "version": {
      "type": "string",
      "pattern": "^[0-9]+\\.[0-9]+\\.[0-9]+$",
      "description": "semver 版本号"
    },
    "data": { "$ref": "#/$defs/DataConfig" },
    "indicators": { "$ref": "#/$defs/IndicatorsConfig" },
    "markers": { "$ref": "#/$defs/MarkersConfig" },
    "chart": { "$ref": "#/$defs/ChartOptions" },
    "theme": { "$ref": "#/$defs/ThemeConfig" }
  },
  "$defs": {
    "DataConfig": {
      "type": "object",
      "required": ["source", "symbol", "startDate", "endDate", "period", "adjust"],
      "additionalProperties": false,
      "properties": {
        "source": { "type": "string", "enum": ["baostock", "dongcai"] },
        "symbol": { "type": "string", "pattern": "^[0-9]{6}$" },
        "exchange": { "type": "string", "enum": ["SH", "SZ", "BJ"] },
        "startDate": { "type": "string", "format": "date" },
        "endDate": { "type": "string", "format": "date" },
        "period": {
          "type": "string",
          "enum": ["daily", "weekly", "monthly", "5min", "15min", "30min", "60min"]
        },
        "adjust": { "type": "string", "enum": ["qfq", "hfq", "none"] }
      }
    },
    "IndicatorsConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "main": {
          "type": "array",
          "items": { "$ref": "#/$defs/MainIndicatorConfig" },
          "maxItems": 5
        },
        "sub": {
          "type": "array",
          "items": { "$ref": "#/$defs/SubIndicatorConfig" },
          "maxItems": 5
        }
      }
    },
    "MainIndicatorConfig": {
      "type": "object",
      "required": ["type", "enabled"],
      "additionalProperties": false,
      "properties": {
        "type": { "type": "string", "enum": ["MA", "BOLL"] },
        "enabled": { "type": "boolean" },
        "params": { "type": "object" }
      },
      "allOf": [
        {
          "if": {
            "properties": { "type": { "const": "MA" } },
            "required": ["type"]
          },
          "then": {
            "properties": {
              "params": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "periods": {
                    "type": "array",
                    "items": { "type": "integer", "minimum": 1, "maximum": 250 },
                    "minItems": 1,
                    "maxItems": 5
                  }
                }
              }
            }
          },
          "else": {
            "properties": {
              "params": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "period": { "type": "integer", "minimum": 1, "maximum": 100 },
                  "multiplier": { "type": "number", "minimum": 0.1, "maximum": 5 }
                }
              }
            }
          }
        }
      ]
    },
    "SubIndicatorConfig": {
      "type": "object",
      "required": ["type", "enabled"],
      "additionalProperties": false,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["VOLUME", "MACD", "RSI", "CCI", "STOCH", "MOM", "WMSR", "KST", "FASTK"]
        },
        "enabled": { "type": "boolean" },
        "params": { "type": "object" }
      },
      "allOf": [
        {
          "if": { "properties": { "type": { "const": "MACD" } } },
          "then": {
            "properties": {
              "params": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "fast": { "type": "integer", "minimum": 1, "maximum": 50 },
                  "slow": { "type": "integer", "minimum": 1, "maximum": 100 },
                  "signal": { "type": "integer", "minimum": 1, "maximum": 50 }
                }
              }
            }
          }
        },
        {
          "if": { "properties": { "type": { "const": "RSI" } } },
          "then": {
            "properties": {
              "params": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "period1": { "type": "integer", "minimum": 1, "maximum": 100 },
                  "period2": { "type": "integer", "minimum": 1, "maximum": 100 },
                  "period3": { "type": "integer", "minimum": 1, "maximum": 100 }
                }
              }
            }
          }
        }
      ]
    },
    "MarkersConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "showVolumePriceMarkers": { "type": "boolean" },
        "showExtremaMarkers": { "type": "boolean" },
        "customMarkers": {
          "type": "array",
          "items": { "$ref": "#/$defs/CustomMarker" },
          "maxItems": 100
        },
        "legend": { "$ref": "#/$defs/LegendConfig" }
      }
    },
    "CustomMarker": {
      "type": "object",
      "required": ["id", "date", "shape"],
      "additionalProperties": false,
      "properties": {
        "id": { "type": "string", "maxLength": 64 },
        "date": {
          "type": "string",
          "description": "日期时间字符串，日K用 YYYY-MM-DD，分钟K用 YYYY-MM-DD HH:mm",
          "pattern": "^[0-9]{4}-[0-9]{2}-[0-9]{2}( [0-9]{2}:[0-9]{2})?$"
        },
        "shape": {
          "type": "string",
          "enum": ["arrow_up", "arrow_down", "flag", "circle", "rectangle", "diamond"]
        },
        "groupKey": { "type": "string", "maxLength": 32 },
        "offset": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "x": { "type": "number", "minimum": -500, "maximum": 500 },
            "y": { "type": "number", "minimum": -500, "maximum": 500 }
          }
        },
        "style": { "$ref": "#/$defs/MarkerStyle" },
        "label": { "$ref": "#/$defs/MarkerLabel" },
        "metadata": {
          "type": "object",
          "maxProperties": 20,
          "additionalProperties": {
            "type": ["string", "number", "boolean", "null"],
            "maxLength": 200
          }
        }
      }
    },
    "MarkerStyle": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "fillColor": { "type": "string", "pattern": "^(#[0-9a-fA-F]{3,8}|rgb\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*\\)|rgba\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*[\\d.]+\\s*\\))$" },
        "strokeColor": { "type": "string", "pattern": "^(#[0-9a-fA-F]{3,8}|rgb\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*\\)|rgba\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*[\\d.]+\\s*\\))$" },
        "textColor": { "type": "string", "pattern": "^(#[0-9a-fA-F]{3,8}|rgb\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*\\)|rgba\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*[\\d.]+\\s*\\))$" },
        "size": { "type": "number", "minimum": 4, "maximum": 50 },
        "lineWidth": { "type": "number", "minimum": 0.5, "maximum": 10 },
        "opacity": { "type": "number", "minimum": 0, "maximum": 1 }
      }
    },
    "MarkerLabel": {
      "type": "object",
      "required": ["text"],
      "additionalProperties": false,
      "properties": {
        "text": { "type": "string", "maxLength": 50 },
        "position": { "type": "string", "enum": ["left", "right", "top", "bottom", "inside"] },
        "align": { "type": "string", "enum": ["start", "center", "end"] },
        "fontSize": { "type": "number", "minimum": 8, "maximum": 24 },
        "offset": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "x": { "type": "number", "minimum": -500, "maximum": 500 },
            "y": { "type": "number", "minimum": -500, "maximum": 500 }
          }
        }
      }
    },
    "LegendConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "enabled": { "type": "boolean" },
        "position": { "type": "string", "enum": ["bottom-right", "bottom-left", "top-right", "top-left"] },
        "onClick": { "type": "string", "enum": ["highlight", "toggle", "none"] }
      }
    },
    "ChartOptions": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "kWidth": { "type": "number", "minimum": 2, "maximum": 50 },
        "kGap": { "type": "number", "minimum": 0, "maximum": 20 },
        "autoScrollToRight": { "type": "boolean" }
      }
    },
    "ThemeConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "priceUpColor": { "type": "string", "pattern": "^#[0-9a-fA-F]{6}$" },
        "priceDownColor": { "type": "string", "pattern": "^#[0-9a-fA-F]{6}$" }
      }
    }
  }
}
